export default "__VITE_ASSET__CmLzCkC2__"